import { render, staticRenderFns } from "./packingOrder.vue?vue&type=template&id=51627499&scoped=true"
import script from "./packingOrder.vue?vue&type=script&lang=js"
export * from "./packingOrder.vue?vue&type=script&lang=js"
import style0 from "./packingOrder.vue?vue&type=style&index=0&id=51627499&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51627499",
  null
  
)

export default component.exports